import React from "react";

export default function ProtectedPaidFeature({
  hasAccess,
  children,
  title = "Subscription Required",
}) {
  if (hasAccess) {
    return children;
  }

  return (
    <div
      style={{
        marginTop: 20,
        padding: 20,
        borderRadius: 14,
        border: "1px solid #f59e0b",
        background: "#fffbeb",
        color: "#111827",
      }}
    >
      <h3 style={{ marginTop: 0 }}>{title}</h3>
      <p style={{ marginBottom: 0 }}>
        This feature is available only for paid users.
      </p>
    </div>
  );
}